"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _buttonControl = _interopRequireDefault(require("../button-control"));

var _classnames = _interopRequireDefault(require("classnames"));

var EmptyPage = function EmptyPage(_ref) {
  var fullHeight = _ref.fullHeight,
      img_src = _ref.img_src,
      header = _ref.header,
      text = _ref.text,
      button = _ref.button,
      children = _ref.children;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('control_empty', {
      'control_empty--full-height': fullHeight
    })
  }, (0, _preact.h)("img", {
    className: "control_empty_image",
    src: (0, _absoluteUrlRuntime.resolveUrl)(img_src)
  }), (0, _preact.h)("h2", {
    className: "control_empty_message_header bold"
  }, header), (0, _preact.h)("div", {
    className: "control_empty_message_description"
  }, text), button && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(button.link),
    className: "control_empty--btn"
  }, (0, _preact.h)(_buttonControl.default, {
    newStyle: true,
    size: "medium",
    title: button.text,
    variant: "brand"
  })), children && children);
};

var _default = EmptyPage;
exports.default = _default;